<template>
  <x-page title="确认订单" :loading="loading">
    <template v-if="!loading">
      <!-- 收货地址 -->
      <div
        v-if="!is全是虚拟商品"
        v-track="{
          name: '选择地址',
          id: 'cl9xjnck6002o6krlhr36aovg',
        }"
        :class="_.address"
      >
        <x-card
          v-if="!address.id"
          :class="_.add"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/place/地址.png')" :class="_.icon" />
          <div :class="_.text">请添加收货地址</div>
        </x-card>
        <x-card
          v-else
          :class="_.content"
          @click.native="handleChooseAddressClick"
        >
          <img
            :src="require('./images/place/已选择地址.png')"
            :class="_.icon"
          />
          <div :class="_.left">
            <div :class="_.hd">
              <div :class="_.user">{{ address.receiver }}</div>
              <div :class="_.phone">{{ address.phoneNo }}</div>
              <div v-if="address.defaultFlag" :class="_.tag">默认</div>
            </div>
            <div :class="_.bd">
              {{
                `${address.province}${address.city}${address.county}${address.detail}`
              }}
            </div>
          </div>
          <van-icon name="arrow" :class="_.arrow" />
        </x-card>
      </div>

      <!-- 商品列表 -->
      <x-card
        v-for="merchant in preOrderData.orderInfo"
        :key="merchant.merchantId"
        :class="_.merchant"
      >
        <div :class="[_.hd, _._hairlineBottom]">
          <img
            :src="merchant.merchantPic || require('./images/place/店铺.png')"
            :class="_.logo"
          />
          <div :class="_.name">{{ merchant.merchantName }}</div>
        </div>
        <div :class="_.bd">
          <div
            v-for="goods in merchant.commodityInfo"
            :key="goods.commodityId"
            :class="_.goods"
          >
            <van-image :src="goods.commodityPic" :class="_.cover" fit="cover" />
            <div :class="_.main">
              <div :class="_.top">
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ goods.commodityName }}
                  </div>
                  <div :class="_.desc">{{ goods.skuDesc }}</div>
                </div>
                <div :class="_.info">
                  <div :class="_.price">￥{{ goods.unitPrice }}</div>
                  <div :class="_.amount">x{{ goods.count }}</div>
                </div>
              </div>
              <div v-if="goods.bonusText" :class="_.tips">
                交易完成可获得{{ goods.bonusText }}
              </div>
            </div>
          </div>
        </div>
      </x-card>

      <!-- 拼团玩法 -->
      <x-card v-if="is拼团下单" :class="_.groupBuying">
        <div :class="[_.hd, _._hairlineBottom]">
          <div :class="_.title">
            <img :src="require('./images/place/拼团.png')" :class="_.icon" />
            <div :class="_.text">拼团玩法</div>
          </div>
          <div :class="_.more" @click="handleGroupBuyingRuleClick">
            详细规则
            <x-icon name="arrow" :class="_.arrow" />
          </div>
        </div>
        <div :class="_.bd">
          <img
            :src="
              preOrderData.groupType === 'NORMAL'
                ? require('./images/place/拼团一阶玩法.png')
                : require('./images/place/拼团多阶玩法.png')
            "
            :class="_.image"
          />
        </div>
      </x-card>

      <!-- 概况 -->
      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">打包费</div>
          <div :class="_.value">¥{{ preOrderData.packagePrice }}</div>
        </div>
        <div :class="_.item">
          <div :class="_.label">用户配送费</div>
          <div :class="_.value">¥{{ postFee }}</div>
        </div>
        <div
          v-if="!is秒杀下单 && !is拼团下单"
          v-track="{
            name: '确认订单-优惠券',
            id: 'ab985c22-d4f4-45f4-93af-fd0a71c89d26',
          }"
          :class="_.item"
        >
          <div :class="_.label">优惠券</div>
          <x-pick-coupon
            v-model="couponData"
            :params="pickCouponParams"
            :class="_.value"
          >
            <template #default="{ noCoupon, selectedCoupon }">
              <span
                :class="noCoupon || !selectedCoupon.couponId ? _.gray : _.red"
              >
                {{
                  noCoupon
                    ? '无可用优惠券'
                    : selectedCoupon.couponId
                    ? `-¥${selectedCoupon.discountedAmt}`
                    : '选择优惠券'
                }}
              </span>
              <van-icon name="arrow" :class="_.arrow" />
            </template>
          </x-pick-coupon>
        </div>
        <div v-for="item in discountData" :key="item.name" :class="_.item">
          <div :class="_.label">{{ item.name }}</div>
          <div :class="_.value">
            <span :class="_.red"> -¥{{ item.amount }} </span>
          </div>
        </div>
        <div :class="[_.item, _.special]">
          <div :class="_.label"></div>
          <div :class="_.value">
            已优惠
            <span :class="[_.red, _.price]">¥{{ discountMoney }}</span>
            <span :class="_.divider" />
            合计
            <span :class="[_.red, _.price]">¥{{ actualMoney }}</span>
          </div>
        </div>
      </x-card>

      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">备注</div>
          <div :class="_.value">
            <input
              v-model="orderData[preOrderData.orderInfo[0].orderId].remark"
              v-fix-keyboard
              type="text"
              :class="_.input"
              placeholder="选填，给商家留言"
              maxlength="20"
            />
          </div>
        </div>
        <div :class="_.item">
          <div :class="_.label">配送时间</div>
          <x-picker
            v-model="deliveryTimeIndex"
            title="选择预计送达时间"
            :class="_.value"
            :data="deliveryTimeData"
            confirm-on-pick
          >
            <template #default="{ label }">
              {{ label }}
              <van-icon name="arrow" :class="_.arrow" />
            </template>
          </x-picker>
        </div>
      </x-card>

      <div v-if="preOrderData.supportPayType" :class="_.pointTips">
        * 商品支持消费金支付，消费金无法使用优惠抵扣，无法售后退款。
      </div>

      <!-- 操作 -->
      <x-bottom-bar>
        <div :class="_.actions">
          <div :class="_.agree" @click="isAgree = !isAgree">
            <img
              v-if="isAgree"
              src="./images/place/已同意.png"
              :class="_.icon"
            />
            <img v-else src="./images/place/未同意.png" :class="_.icon" />
            我已阅读并同意<span @click.stop.prevent="handleTreatyClick"
              >《多多快送配送协议》</span
            >
          </div>
          <div :class="_.ft">
            <div :class="_.total">￥{{ actualMoney }}</div>
            <div :class="_.grow" />
            <div
              v-if="preOrderData.supportPayType"
              v-track="{
                name: '消费金支付',
                id: 'claur4ghb0002txrldhhmf8pw',
              }"
              :class="[_.button, _.secondary]"
              @click="handlePointPayClick"
            >
              消费金支付
            </div>
            <div
              v-track="{
                name: '立即支付',
                id: 'cl9xjnudq002q6krlghpr9tso',
              }"
              :class="_.button"
              @click="handlePayClick"
            >
              立即支付
            </div>
          </div>
        </div>
      </x-bottom-bar>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { addDays, formatDate } from 'vtils/date'
  import { AddressBridge } from '@/views/address/bridge'
  import {
    apiGroupBuyingTradeCalcPostFee,
    apiGroupBuyingTradePreOrder,
    apiTradeGeneralTradeCalcPostFee,
    apiTradeGeneralTradePreOrder,
    apiTradeGeneralTradeTradeOrder,
    apiTradeSecKillTradeSeckillCalcPostFee,
    apiTradeSecKillTradeSeckillConfirmResult,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { flatten, sumBy, values, wait } from 'vtils'
  import {
    getManyGoodsBonus,
    loopUntil,
    mapQuery,
    onPageVisibilityChange,
    prepareData,
    submit,
    Track,
  } from '@/utils'
  import { getPageUrl, navigateBack, redirectTo } from '@/router'
  import { globalModel } from '@/model'
  import { handleGoodsError } from '@/views/goods/exports'
  import { mall } from '@/mall_jssdk'

  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })

  export default Vue.extend({
    mixins: [
      globalModel.mixin,
      mapQuery({
        type: {
          key: 'type',
        },
        _preOrderData: {
          key: 'data',
          json: true,
        },
        _preOrderRequestData: {
          key: 'preOrderRequestData',
          json: true,
        },
      }),
      Track.provideMark(() => ({
        page: '确认订单',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 收货地址
      address: {},

      // 下单数据
      orderData: {},

      // 优惠券数据
      couponData: {},

      // 邮费
      postFee: 0,

      // 订单 ID 的邮费
      orderIdToPostFee: {},

      // 最新的预下单数据
      lastPreOrderData: {},

      // 折扣数据
      discountData: [],

      // 配送时间数据
      deliveryTimeData: [
        {
          label: '尽快送出',
          value: 0,
        },
        {
          label: `明天（${formatDate(addDays(new Date(), 1), 'm月d日')}）`,
          value: 1,
        },
        {
          label: `后天（${formatDate(addDays(new Date(), 2), 'm月d日')}）`,
          value: 2,
        },
      ],

      // 配送时间索引
      deliveryTimeIndex: 0,

      // 是否同意协议
      isAgree: true,
    }),

    computed: {
      // 是否拼团下单
      is拼团下单() {
        return this.type === 'groupBuying'
      },
      // 是否秒杀下单
      is秒杀下单() {
        return this.type === 'seckill'
      },
      // 预下单数据
      preOrderData() {
        return this.lastPreOrderData.preOrderId
          ? this.lastPreOrderData
          : this._preOrderData
      },
      // 预下单请求数据
      preOrderRequestData() {
        return this._preOrderRequestData
      },
      // 商品 ID 列表
      goodsIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityId))
          return res
        }, [])
      },
      // 商品资源 ID 列表（用于查询优惠券）
      goodsResourceIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(
            ...merchant.commodityInfo.map(goods =>
              JSON.stringify({
                id: goods.resourceId,
                name: goods.commodityName,
                price: goods.unitPrice,
                count: goods.count,
                totalAmt: mall.calculator.sub(
                  goods.totalPrice,
                  goods.discountActivityAmount,
                ),
                superimposeDiscountType: this.discountData[0]?.type || null,
                categoryId: goods.categoryId,
              }),
            ),
          )
          return res
        }, [])
      },
      // 选择优惠券的参数
      pickCouponParams() {
        return {
          goodsIdList: this.goodsResourceIds,
          amt: this.preOrderData.orderAmount,
          discountedAmt: mall.calculator.add(
            ...this.discountData.map(item => item.amount),
          ),
          businessType: this.preOrderData.businessType,
          unitOrgCode: this.preOrderData.unitOrgCode,
        }
      },
      // 商品数量
      totalGoods() {
        return sumBy(
          this.preOrderData.orderInfo,
          merchant => merchant.totalQuantity,
        )
      },
      // 优惠金额
      discountMoney() {
        return mall.calculator.add(
          // 折扣金额
          ...this.discountData.map(item => item.amount),
          // 优惠券金额
          this.is秒杀下单 || this.is拼团下单
            ? 0
            : this.couponData.discountedAmt || 0,
        )
      },
      // 实付金额
      actualMoney() {
        return mall.calculator.add(
          _ =>
            _.sub(
              // 订单金额
              this.preOrderData.orderAmount,
              // 减去折扣金额
              _ => _.add(...this.discountData.map(item => item.amount)),
              // 减去优惠券金额
              this.is秒杀下单 || this.is拼团下单
                ? 0
                : this.couponData.discountedAmt || 0,
            ),
          // 加上邮费
          this.postFee,
        )
      },
      is全是虚拟商品() {
        return this.preOrderData.preOrderContentType === 2
      },
    },

    watch: {
      // 计算邮费
      address: {
        immediate: true,
        async handler(address) {
          if (!address.id) {
            this.postFee = 0
            this.lastPreOrderData = this._preOrderData
          } else {
            await submit(async $ => {
              await $.start()
              this.lastPreOrderData = await (this.is拼团下单
                ? apiGroupBuyingTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  }).catch(handleGoodsOrderError)
                : this.is秒杀下单
                ? // 秒杀商品只预下单一次
                  Promise.resolve(this._preOrderData)
                : apiTradeGeneralTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  })
              ).then(async res => {
                const goodsList = flatten(
                  res.orderInfo.map(orderItem => orderItem.commodityInfo),
                )
                const bonusMap = await getManyGoodsBonus(goodsList)
                for (const goods of goodsList) {
                  goods.bonusText = bonusMap[goods.skuId] || ''
                }
                return res
              })
              await wait(0)
              const { orderInfo } = await (this.is拼团下单
                ? apiGroupBuyingTradeCalcPostFee
                : this.is秒杀下单
                ? apiTradeSecKillTradeSeckillCalcPostFee
                : apiTradeGeneralTradeCalcPostFee)({
                preOrderId: this.preOrderData.preOrderId,
                consigneeAddress: {
                  province: this.address.province,
                  city: this.address.city,
                  area: this.address.county,
                  areaCode: this.address.districtCode,
                  detail: this.address.detail,
                  name: this.address.receiver,
                  phoneNo: this.address.phoneNo,
                },
              })
              this.postFee = sumBy(orderInfo, item => item.postFee || 0)
              this.orderIdToPostFee = orderInfo.reduce((res, item) => {
                res[item.orderId] = item.postFee
                return res
              }, {})
            })
          }
        },
      },
      // 计算订单提交数据
      preOrderData: {
        immediate: true,
        handler(preOrderData) {
          this.orderData = preOrderData.orderInfo.reduce((res, merchant) => {
            res[merchant.orderId] = {
              orderId: merchant.orderId,
              remark: '',
            }
            return res
          }, {})
          this.discountData = preOrderData.discountItems || []
        },
      },
    },

    mounted() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { address } = await prepareData({
          address: AddressBridge.getDefaultAddress().then(
            res => res || {},
            () => ({}),
          ),
        })
        this.address = address
        this.loading = false
      },

      // 点击选择地址
      async handleChooseAddressClick() {
        const address = await AddressBridge.chooseAddress(this.goodsIds)
        if (address && address.id) {
          this.address = address
        }
      },

      // 点击拼团规则
      handleGroupBuyingRuleClick() {
        dcb.navigateTo({
          url: this.preOrderData.ruleUrl,
        })
      },

      // 协议
      handleTreatyClick() {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa9e368412689d01849de08552007f',
        })
      },

      // 点击立即支付按钮
      async handlePayClick() {
        await submit(async $ => {
          if (!this.isAgree) {
            return $.fail('请先阅读并同意配送协议')
          }
          if (!this.is全是虚拟商品 && !this.address.id) {
            return $.fail('请先添加收货地址')
          }
          await $.start()
          let payData = await apiTradeGeneralTradeTradeOrder({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: this.address.detail,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
            deliverDate:
              this.deliveryTimeData[this.deliveryTimeIndex].value === 0
                ? undefined
                : formatDate(
                    addDays(
                      new Date(),
                      this.deliveryTimeData[this.deliveryTimeIndex].value,
                    ),
                    'yyyy-mm-dd',
                  ),
          }).catch(handleGoodsOrderError)
          if (this.is秒杀下单) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
            )
            if (res.confirmState === 2) return $.fail(res.msg)
            payData = res.result
          }
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            await wait(1000)
            redirectTo('InstantDeliveryOrderSuccess')
          } catch {
            redirectTo('InstantDeliveryOrderIndex')
          }
        })
      },

      // 点击消费金支付按钮
      async handlePointPayClick() {
        await submit(async $ => {
          if (!this.isAgree) {
            return $.fail('请先阅读并同意配送协议')
          }
          if (!this.is全是虚拟商品 && !this.address.id) {
            return $.fail('请先添加收货地址')
          }
          await $.start()
          let payData = await apiTradeGeneralTradeTradeOrder({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: this.address.detail,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            payType: 12,
            openId: undefined,
            deliverDate:
              this.deliveryTimeData[this.deliveryTimeIndex].value === 0
                ? undefined
                : formatDate(
                    addDays(
                      new Date(),
                      this.deliveryTimeData[this.deliveryTimeIndex].value,
                    ),
                    'yyyy-mm-dd',
                  ),
          }).catch(handleGoodsOrderError)
          if (this.is秒杀下单) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
            )
            if (res.confirmState === 2) return $.fail(res.msg)
            payData = res.result
          }
          const payUrl = payData.thirdParams.payUrl.replace(
            'SUCURL',
            encodeURIComponent(getPageUrl('InstantDeliveryOrderSuccess')),
          )
          const off = onPageVisibilityChange(visible => {
            if (visible) {
              off()
              submit(async $ => {
                $.start()
                await wait(1000)
                redirectTo('InstantDeliveryOrderIndex')
              })
            }
          })
          dcb.navigateTo({
            url: payUrl,
          })
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .address {
    .add {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 19px;
        height: 19px;
      }

      .text {
        margin-left: 2px;
        font-size: 14px;
        color: #222222;
      }

      &:active {
        opacity: 0.8;
      }
    }

    .content {
      display: flex;
      align-items: center;

      .icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
      }

      .left {
        margin-left: 12px;
        flex-grow: 1;

        .hd {
          display: flex;
          align-items: center;

          .user {
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .phone {
            margin-left: 8px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }

          .tag {
            margin-left: 8px;
            background: #fff2f1;
            border-radius: 1000px;
            font-size: 10px;
            color: #ff111c;
            padding: 2px 5px;
            line-height: 1;
          }
        }

        .bd {
          margin-top: 4px;
          font-size: 12px;
          color: #222222;
          line-height: 16px;
        }
      }

      .arrow {
        margin-left: 24px;
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: center;
      padding-bottom: 12px;

      .logo {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        user-select: none;
        -webkit-touch-callout: none;
      }

      .name {
        margin-left: 6px;
        font-size: 14px;
        color: #222222;
      }
    }

    .bd {
      .goods {
        margin-top: 14px;
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          overflow: hidden;
        }

        .main {
          margin-left: 12px;
          flex-grow: 1;

          .top {
            display: flex;

            .content {
              flex-grow: 1;

              .name {
                font-size: 14px;
                color: #222222;
                line-height: 20px;
              }

              .desc {
                display: inline-block;
                margin-top: 4px;
                border-radius: 1000px;
                font-size: 10px;
                color: #888888;
              }
            }

            .info {
              margin-left: 20px;
              flex-shrink: 0;

              .price {
                font-size: 12px;
                color: #1d1d1c;
                text-align: right;
              }

              .amount {
                margin-top: 5px;
                font-size: 12px;
                color: #888888;
                text-align: right;
              }
            }
          }

          .tips {
            margin-top: 4px;
            font-size: 10px;
            color: #ff111c;
            line-height: 16px;
          }
        }
      }
    }

    .ft {
      .item {
        margin-top: 12px;
        display: flex;
        align-items: center;

        .label {
          flex-shrink: 0;
          width: 85px;
          text-align: right;
          font-size: 12px;
          color: #222222;
        }

        .value {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 12px;
          color: #888888;

          .input {
            width: 100%;
            appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: 0;

            &::placeholder {
              color: #bebebe;
            }
          }
        }

        .extra {
          flex-shrink: 0;
          font-size: 12px;
          color: #222222;
        }
      }
    }

    .ex {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .count {
        font-size: 12px;
        color: #989898;
        line-height: 18px;
      }

      .label {
        font-size: 12px;
        color: #222222;
        line-height: 18px;
        margin: 0 4px;
      }

      .unit {
        font-size: 10px;
        color: #ff111c;
        line-height: 16px;
        margin-right: 2px;
      }

      .price {
        font-size: 14px;
        color: #ff111c;
        line-height: 18px;
      }
    }
  }

  .groupBuying {
    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .title {
        display: flex;
        align-items: center;

        .icon {
          width: 16px;
          height: 16px;
        }

        .text {
          margin-left: 8px;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }
      }

      .more {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #989898;
        line-height: 17px;

        .arrow {
          font-size: 14px;
          color: #999;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    .bd {
      padding-top: 12px;

      .image {
        width: 100%;
      }
    }
  }

  .brief {
    .item {
      display: flex;
      align-items: center;

      + .item {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        font-size: 14px;
        color: #222222;
      }

      .value {
        flex-grow: 1;
        font-size: 14px;
        color: #222222;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1;

        .gray {
          color: #999;
        }

        .red {
          color: #ff111c;
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }

        .input {
          margin-left: 12px;
          width: 100%;
          appearance: none;
          outline: none;
          box-shadow: none;
          border: none;
          border-radius: 0;
          text-align: right;

          &::placeholder {
            color: #bebebe;
          }
        }
      }

      &.special {
        margin-top: 20px;

        .value {
          .price {
            margin-left: 4px;
          }

          .divider {
            width: 12px;
          }
        }
      }
    }
  }

  .pointTips {
    margin: 12px;
    font-size: 12px;
    color: #ff7c2e;
    line-height: 16px;
  }

  .actions {
    background-color: white;

    .agree {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      padding: 8px 12px;

      .icon {
        flex-shrink: 0;
        margin-right: 3px;
        width: 11px;
        height: 11px;
      }

      span {
        color: #0073ff;
      }
    }

    .ft {
      display: flex;
      align-items: center;
      padding: 8px 12px;

      .amount {
        margin-left: 8px;
        flex-shrink: 0;
        font-size: 12px;
        color: #bebebe;
      }

      .total {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .grow {
        flex-grow: 1;
      }

      .button {
        min-width: 100px;
        height: 34px;
        padding: 0 16px;
        box-sizing: border-box;
        background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: var(--bold-value);
        color: #ffffff;
        white-space: nowrap;

        &:active {
          opacity: 0.9;
        }

        &.secondary {
          background: #ff960a;
        }

        + .button {
          margin-left: 12px;
        }
      }
    }

    + .placeholder {
      height: 120px;
    }
  }
</style>
